export function parseStoreName(raw: string): string {
  return raw.replace(/^[\d\s]+-\s*/, '').trim();
}

export function formatShiftTime(iso: string): string {
  try {
    return new Date(iso).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function isReleaseAllowed(shopperShiftStart: string): boolean {
  const lockTime = new Date(shopperShiftStart).getTime() - 60 * 60 * 1000;
  return Date.now() < lockTime;
}
